module.exports = {"host":"https://inuha.app","hostnlp":"https://node2.mobilesupportbot.com:5051","upload":"https://node1.mobilesupportbot.com:1235"}


//////////////////
// WEBPACK FOOTER
// ./src/config/dev.json
// module id = 9
// module chunks = 47